import { render, staticRenderFns } from "./PricingInfo.vue?vue&type=template&id=06265ef5"
import script from "./PricingInfo.vue?vue&type=script&lang=js"
export * from "./PricingInfo.vue?vue&type=script&lang=js"
import style0 from "./PricingInfo.vue?vue&type=style&index=0&id=06265ef5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports